import React from 'react';
import PropTypes from 'prop-types';
import { isOptionItm, isPositionItm } from 'utils/optionMoneyness';

const OptionLastPrice = ({ item, optionPrice, stockPrice, subOrders, className, children }) => {
    const showItm = subOrders
        ? isPositionItm(item, stockPrice, subOrders)
        : isOptionItm(item, stockPrice);

    return (
        <span className={`option-last-price ${showItm ? 'option-last-price--itm' : ''} ${className || ''}`}>
            {optionPrice}
            {children}
        </span>
    );
};

OptionLastPrice.propTypes = {
    item: PropTypes.object.isRequired,
    optionPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stockPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subOrders: PropTypes.array,
    className: PropTypes.string,
    children: PropTypes.node,
};

export default OptionLastPrice;
